export default "__VITE_ASSET__Dk$M3PnG__"